import { render, staticRenderFns } from "./DepartmentTreeCard.vue?vue&type=template&id=ec7c4b30&scoped=true"
import script from "./DepartmentTreeCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentTreeCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DepartmentTreeCard.vue?vue&type=style&index=0&id=ec7c4b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7c4b30",
  null
  
)

export default component.exports